import React from 'react';
import './autoinsuranceinfoContact.css';
import QuoteInfoFileUpload from '../quoteInfoFileUpload';

function AutoInsuranceContact({ formData, handleChange }) {
  return (
    <div className="autoquoteinfo-contact">
      <div className='autoquoteinfo-contact-abc'>
        <div className='contact-abc-a'>
          <p id='auto-contact-abc-a'>A</p>
          <p id='auto-contact-abc-address'>Address</p>
        </div>
        <div className='contact-abc-b'>
          <p id='auto-contact-abc-b'>B</p>
          <p id='auto-contact-abc-birthdate'>Birthdate</p>
        </div>
        <div className='contact-abc-c'>
          <p id='auto-contact-abc-c'>C</p>
          <p id='auto-contact-abc-contact'>Contact Info</p>
        </div>
      </div>
      <div className='first-last-name-inputs'>
        <input
          type="text"
          id="firstName"
          name="firstName"
          value={formData.firstName}
          onChange={(e) => handleChange('firstName', e.target.value)}
          placeholder='First Name'
          required
        />
        <input
          type="text"
          id="lastName"
          name="lastName"
          value={formData.lastName}
          onChange={(e) => handleChange('lastName', e.target.value)}
          placeholder='Last Name'
          required
        />
      </div>
      <input
        type="tel"
        id="phoneNumber"
        name="phoneNumber"
        value={formData.phoneNumber}
        onChange={(e) => handleChange('phoneNumber', e.target.value)}
        placeholder='Phone'
        required
        pattern="^\(?\d{3}\)?[-\.\s]?\d{3}[-\.\s]?\d{4}$"
        title="Enter a 10-digit phone number (e.g. 123-456-7890)."
      />
      <input
        type="email"
        id="email"
        name="email"
        value={formData.email}
        onChange={(e) => handleChange('email', e.target.value)}
        placeholder='Email'
        required
      />
      <div className='additionalNotes-textarea'>
        <textarea
          id="additionalNotes"
          name="additionalNotes"
          value={formData.additionalNotes}
          placeholder='Is there any additional information you would like your agent to know?'
          onChange={(e) => handleChange('additionalNotes', e.target.value)}
        />
      </div>
      <div className="agent-code-input">
        <label htmlFor="agentCode">If applicable, enter agent code:</label>
        <input
          type="text"
          id="agentCode"
          name="agentCode"
          value={formData.agentCode}
          onChange={(e) => handleChange('agentCode', e.target.value)}
          placeholder='Agent Code'
        />
      </div>
      <div className='contact-what-happens-next'>
        <p><span id='happens-next-bold'>WHAT HAPPENS NEXT</span> - You will receive confirmation who your local agent is and that they are working on your quotes. Within 24 hours your agent will set up a time to go over your quotes to verify everything is correct.</p>
      </div>
    </div>
  );
}

export default AutoInsuranceContact;
